var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125C4.66875 1.125 1.125 4.66875 1.125 9C1.125 13.3313 4.66875 16.875 9 16.875C13.3313 16.875 16.875 13.3313 16.875 9C16.875 4.66875 13.3313 1.125 9 1.125ZM8.38125 4.5H9.61875V10.6875H8.38125V4.5ZM9 14.0625C8.55 14.0625 8.15625 13.6687 8.15625 13.2188C8.15625 12.7688 8.55 12.375 9 12.375C9.45 12.375 9.84375 12.7688 9.84375 13.2188C9.84375 13.6687 9.45 14.0625 9 14.0625Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.0b15e7abf729e00d2e41f0b57aeec04c.svg";
export { ForwardRef as ReactComponent };